import { FormattedDateTime, Link, TableTd, Text, Truncated } from '@customerio/pluma-components/react';
import { isValidTimestamp } from '@/features/people';
import { isEmptyString } from '@/utils/string';

type PersonCellProps = {
  personName: string | undefined;
  personHref: string | undefined;
};

export function RelationshipPersonCell({ personName, personHref }: PersonCellProps) {
  if (personName == null || personHref == null) {
    return (
      <TableTd>
        <Text color="subtle">—</Text>
      </TableTd>
    );
  }

  return (
    <TableTd>
      <Truncated>
        <Link href={personHref} variant="primary" className="fs-mask">
          {personName}
        </Link>
      </Truncated>
    </TableTd>
  );
}

type AttributeCountCellProps = {
  label: string;
  ariaLabel: string;
  onView: () => void;
};

export function RelationshipAttributeCountCell({ label, ariaLabel, onView }: AttributeCountCellProps) {
  return (
    <TableTd className="fs-mask">
      <Link
        variant="secondary"
        isUnderlined
        onClick={onView}
        aria-label={ariaLabel}
        data-test-relationship-attributes-count-label
      >
        {label}
      </Link>
    </TableTd>
  );
}

type AttributeValueCellProps = {
  column: string;
  value: string | undefined;
  onView: () => void;
};

/** A displayed attribute's value, opening the preview; a timestamp reads as a date, a missing one as a dash. */
export function RelationshipAttributeValueCell({ column, value, onView }: AttributeValueCellProps) {
  if (isEmptyString(value)) {
    return <TableTd className="fs-mask">-</TableTd>;
  }

  return (
    <TableTd className="fs-mask">
      <Truncated tooltip={value}>
        <Link variant="secondary" isUnderlined onClick={onView} data-test-relationship-attribute={column}>
          {isValidTimestamp(value) ? (
            <FormattedDateTime
              date={Number(value)}
              format="medium"
              withRelativeDateFromNow
              withTooltip
              isTooltipTriggerUnderlined
            />
          ) : (
            value
          )}
        </Link>
      </Truncated>
    </TableTd>
  );
}

type ViewCellProps = {
  onView: () => void;
};

export function RelationshipViewCell({ onView }: ViewCellProps) {
  return (
    <TableTd className="fs-mask">
      <Link variant="secondary" isUnderlined onClick={onView} data-test-relationship-attribute="view">
        View
      </Link>
    </TableTd>
  );
}
